import { Component, ElementRef, viewChild, inject, OnInit } from '@angular/core';

import { AppConfigService } from 'src/app/core/services/config.service';
import { AppIntroService } from 'src/app/layout/components/app-intro/app-intro.service';

@Component({
  selector: 'app-kibana-dashboard',
  standalone: true,
  templateUrl: './kibana-dashboard.component.html',
})
export class KibanaDashboardComponent implements OnInit {
  private appIntroService = inject(AppIntroService);

  //#region properties
  readonly kibana = viewChild.required<ElementRef<HTMLIFrameElement>>('kibana');
  kibanaDashboardUrl = AppConfigService.config.kibanaDashboard;
  //#endregion

  constructor() {
    this.appIntroService.destroy();
  }

  ngOnInit() {
    const t = setTimeout(() => {
      this.kibana().nativeElement.src = this.kibanaDashboardUrl;
      clearTimeout(t);
    }, 10);
  }
}
